import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router";
import { cn } from "@/shared/lib/utils";
import { Button } from "@/shared/ui/Button";

export const BackButton = ({ to, legend }: { to: string, legend?: string }) => {
  const navigate = useNavigate();

  return (
    <Button
      variant="outline"
      size={legend ? "default" : "icon"}
      onClick={() => navigate(to)}
      aria-label={legend ?? "Retour"}
      className={cn(
        "group flex min-w-9 max-w-9 items-center gap-0 overflow-hidden transition-[max-width] duration-200 ease-in-out hover:max-w-64",
      )}
    >
      <ArrowLeft className="h-4 w-4 shrink-0" />
      {legend
        ? (
          <span className="pl-0 max-w-0 overflow-hidden whitespace-nowrap opacity-0 transition-[max-width,opacity,padding] duration-300 ease-in-out group-hover:pl-2 group-hover:max-w-48 group-hover:opacity-100">
            {legend}
          </span>
        )
        : null}
    </Button>
  );
};
